export const isValidEffectiveDate = (effectiveDate: string) => {
  // Check for mm/dd/yyyy format
  const dateFormatRegex = /^\d{2}\/\d{2}\/\d{4}$/;
  return dateFormatRegex.test(effectiveDate);
};
